export default {"src":"/_next/static/media/email-hero-blank.f3ecf063.svg","height":240,"width":210,"blurWidth":0,"blurHeight":0};